<div class="c-sidebar__logo">
  <div class="c-sidebar__logo-inner">
    <div class="c-sidebar__logo-text">
      <div class="c-sidebar__logo-title" p500UITooltip [tooltipData]="header?.title">{{ header?.title }}</div>
      <div class="c-selector__el-subtitle">{{ header?.subtitle }}</div>
    </div>
  </div>

  <div class="c-sidebar__logo-menu -isShow">
    <gtd-ui-current-time></gtd-ui-current-time>
  </div>
</div>
<div class="c-sidebar__selector c-sidebar__mobile">
  <p500-ui-applications-selector-mobile
    class="c-sidebar__application-mobile"
    [applications]="applications"
    [header]="header"
  ></p500-ui-applications-selector-mobile>

  <div class="c-sidebar__logo-menu -isShow">
    <gtd-ui-current-time></gtd-ui-current-time>
  </div>
</div>
